import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { List, Map, fromJS } from 'immutable';
import { Icon, Dropdown, Dimmer, Progress, Image } from 'semantic-ui-react';
import { TextField, Tooltip, IconButton } from 'material-ui';

import { ExamStep, LeakCountInfo } from 'components';

import { targetEmailAsyncValidate } from 'libs/validation';
import Scrollbar from 'libs/Scrollbar';
import * as common from 'libs/commonFunc';
import * as commonVar from 'libs/commonVar';

import {
  DetailTemplate,
  Button,
  TagItem,
  ReduxFormMaterialTextField,
  ReduxFormHiddenInput,
  MaterialSnackbar,
  Loading,
  TargetDetailExamChart
} from 'components';

import styles from './TargetDetail.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

// 대상자 정보 컴포넌트
const TargetInfoComponent = ({ formatMessage, value, type, targetNo, onActiveEditMode }) => {
  return (
    <div
      className={cx('isEditPossible')}
      onClick={e => {
        onActiveEditMode(e, value, type, targetNo);
      }}
      title={defineMessages(formatMessage({ id: 'TargetDetail_1', defaultMessage: '편집하려면 클릭하세요' }))}>
      <div className={cx('info-text')}>{!!value ? value : '-'}</div>
      <div className={cx('editIcon')}>
        <Icon name="pencil" />
      </div>
    </div>
  );
};

class TargetDetail extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      targetNoArray,
      tagDataByTagNo,
      targetDataByTargetNo,
      isEditType,
      isEditData,
      isSnackbar,
      searchText,
      // function
      onActiveEditMode,
      onToggleSnackbar,
      onToggleDetailView,
      onEditSave,
      onEditCancel,
      onEditTargetTagSave,
      handleChangeTag,
      onMoveScroll,
      onRefRegister,
      onGetTargetExamList,
      onGetEduHistory,
      handleSearchChange,
      handleBlur
    } = this.props;
    const {
      // 훈련 이력 보기/닫기
      isOpenTargetExam,
      // 훈련 이력 보기/닫기 function
      onToggleTargetExam,
      // 훈련 이력 로딩
      isLoadingTargetExam,
      // 훈련 이력
      targetExam,
      // 교육 이력 로딩
      isLoadingEdu,
      // 교육 이력
      eduList
    } = this.props;

    const btDatas = [
      {
        id: 'move-info',
        iconName: 'id card outline',
        content: defineMessages(formatMessage({ id: 'TargetDetail_2', defaultMessage: '대상자 정보' })),
        isView: true
      },
      {
        id: 'move-tag',
        iconName: 'hashtag',
        content: defineMessages(formatMessage({ id: 'TargetDetail_3', defaultMessage: '태그' })),
        isView: true
      },
      {
        id: 'move-examList',
        iconName: 'content',
        content: defineMessages(formatMessage({ id: 'TargetDetail_4', defaultMessage: '훈련 이력' })),
        isView: true
      },
      {
        id: 'move-memo',
        iconName: 'pencil',
        content: defineMessages(formatMessage({ id: 'TargetDetail_5', defaultMessage: '메모' })),
        isView: true
      }
    ];

    // -------------------------------------- 대상자 정보 -----------------------------------------
    let targetInfo = Map({
      targetNo: '-',
      targetName: '-',
      targetEmail: '-',
      targetPhone: '-',
      targetDivision: '-',
      targetPosition: '-',
      targetDetail: '',
      createUser: '-',
      userName: '-',
      userEmail: '-',
      emailDomain: '-',
      extraInfo: '-',
      modifyEpoch: '-',
      regEpoch: '-'
    });

    // 데이터가 없는 경우
    let isNoData = false;
    if (targetNoArray.size === 1 && typeof targetDataByTargetNo.get(String(targetNoArray.get(0))) !== 'undefined') {
      targetInfo = targetDataByTargetNo.get(String(targetNoArray.get(0)));
    } else {
      isNoData = true;
    }

    // 수정 모드에서의 저장, 취소 버튼
    const EditButton = (
      <div className={cx('bt-icon-area')}>
        <Button
          className={cx('bt-icon')}
          icon
          title={defineMessages(formatMessage({ id: 'TargetDetail_6', defaultMessage: '저장' }))}
          onClick={() => {
            onEditSave();
          }}>
          <Icon name="checkmark" />
        </Button>
        <Button
          className={cx('bt-icon')}
          icon
          title={defineMessages(formatMessage({ id: 'TargetDetail_7', defaultMessage: '취소' }))}
          onClick={() => {
            onEditCancel();
          }}>
          <Icon name="cancel" />
        </Button>
      </div>
    );

    // ----------------------------------------- 태그 -----------------------------------------
    let TagListComponent = <div className={cx('tagTarget-area')}>-</div>;
    if (typeof targetInfo.get('tagList') !== 'undefined') {
      // 태그 수정 모드
      if (isEditType === 'targetTag') {
        // 전체 태그 리스트
        const tagDataArray = [];
        tagDataByTagNo.map(tagItem => {
          tagDataArray.push({ key: tagItem.get('tagNo'), value: tagItem.get('tagNo'), text: tagItem.get('tagName') });
        });

        TagListComponent = (
          <div className={cx('editMode-area', 'no-enter')}>
            <div className={cx('tagTarget-dropdown-wrapper')}>
              <Dropdown
                className={cx('tagTarget-dropdown')}
                placeholder={defineMessages(
                  formatMessage({ id: 'TargetDetail_8', defaultMessage: '태그를 입력하세요' })
                )}
                name="targetTag"
                fluid
                multiple
                search
                selection
                autoFocus
                options={tagDataArray}
                onChange={handleChangeTag}
                value={isEditData.get('targetTag')}
                onSearchChange={handleSearchChange}
                onBlur={handleBlur}
              />
              <div className={cx('tagTarget-bt-area')}>
                <Button
                  className={cx('bt-icon')}
                  icon
                  disabled={!!searchText}
                  title={defineMessages(formatMessage({ id: 'TargetDetail_6', defaultMessage: '저장' }))}
                  onClick={() => {
                    onEditSave();
                  }}>
                  <Icon name="checkmark" />
                </Button>
                <Button
                  className={cx('bt-icon')}
                  icon
                  title={defineMessages(formatMessage({ id: 'TargetDetail_7', defaultMessage: '취소' }))}
                  onClick={() => {
                    onEditCancel();
                  }}>
                  <Icon name="cancel" />
                </Button>
              </div>
            </div>
            <ReduxFormHiddenInput name="targetTag" />
          </div>
        );
        // 태그 뷰
      } else {
        const TagInnerComponent = [];
        const tagDataArray = [];
        if (!targetInfo.get('tagList')) {
          TagInnerComponent.push(
            defineMessages(formatMessage({ id: 'TargetDetail_9', defaultMessage: '태그를 등록하세요' }))
          );
        } else {
          targetInfo.get('tagList').map(tagNo => {
            if (tagNo && typeof tagDataByTagNo.get(String(tagNo)) !== 'undefined') {
              tagDataArray.push(tagNo);

              TagInnerComponent.push(
                <TagItem
                  key={tagNo}
                  tagItem={tagDataByTagNo.get(String(tagNo))}
                  className={cx('targetItem-tagItem')}
                  size="small"
                />
              );
            }
          });
        }

        TagListComponent = (
          <div
            className={cx('tagTarget-area', 'isEditPossible')}
            onClick={e => {
              onActiveEditMode(e, tagDataArray, 'targetTag', targetInfo.get('targetNo'));
            }}
            title={defineMessages(formatMessage({ id: 'TargetDetail_1', defaultMessage: '편집하려면 클릭하세요' }))}>
            <div className={cx('editMode-area')}>{TagInnerComponent}</div>
            <div className={cx('editIcon')}>
              <Icon name="pencil" />
            </div>
          </div>
        );
      }
    }

    // ----------------------------------------- 훈련 이력 -----------------------------------------
    // 훈련 이력의 토탈 차트 정보

    const ExamListComponent =
      (targetExam.get('data').size === 0 && (
        <div>{defineMessages(formatMessage({ id: 'TargetDetail_10', defaultMessage: '훈련 이력 없음' }))}</div>
      )) ||
      targetExam.get('data').map((data, index) => {
        const isPhishing = 4 === data.get('examType') ? true : false;

        return (
          <div key={index} className={cx('targetExam-set')}>
            <div className={cx('targetExam-summary')}>
              <div className={cx('targetExam-title')}>
                <Tooltip
                  key={index}
                  title={
                    data.get('examName') +
                    ' (' +
                    common.timeFormatFromUTCEpoch(data.get('examStartEpoch'), 3) +
                    ' ~ ' +
                    common.timeFormatFromUTCEpoch(data.get('examEndEpoch'), 3) +
                    ')'
                  }
                  placement="bottom">
                  <div className={cx('ellipsis')}>
                    <span>{data.get('examName')} </span>
                    <span className={cx('exam-period')}>
                      {'(' +
                        common.timeFormatFromUTCEpoch(data.get('examStartEpoch'), 3) +
                        ' ~ ' +
                        common.timeFormatFromUTCEpoch(data.get('examEndEpoch'), 3) +
                        ')'}
                    </span>
                  </div>
                </Tooltip>
                <div className={cx('targetExam-bt-area')}>
                  {!!data.get('readEpoch') && (
                    <IconButton
                      color="primary"
                      className={cx('bt-toggleView')}
                      onClick={e => {
                        e.stopPropagation();
                        onToggleTargetExam(data.get('examNo'));
                      }}>
                      <Image
                        src={
                          isOpenTargetExam.indexOf(data.get('examNo')) !== -1
                            ? '/img/target/ico_close.png'
                            : '/img/target/ico_open.png'
                        }
                      />
                    </IconButton>
                  )}
                </div>
              </div>
              <div className={cx('targetExam-content')}>
                <div
                  className={cx('targetExam-item', {
                    'color-orange': !!data.get('readEpoch')
                  })}
                  title={defineMessages(formatMessage({ id: 'TargetDetail_11', defaultMessage: '열람' }))}>
                  <span className={cx('title')}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_11', defaultMessage: '열람' }))}
                  </span>
                </div>
                {/* 우선 다운로드 개수 맞추는게 더 중요해서 다운로드도 무조건 나오도록 수정 */}
                {/* {(2 & data.get('linkAttach') || isPhishing) && ( */}
                <div
                  className={cx('targetExam-item', {
                    'color-down': !!data.get('downloadEpoch')
                  })}
                  title={
                    isPhishing
                      ? defineMessages(formatMessage({ id: 'TargetDetail_35', defaultMessage: '접속' }))
                      : defineMessages(formatMessage({ id: 'CtExamChart_6', defaultMessage: '다운' }))
                  }>
                  <span className={cx('title')}>
                    {isPhishing
                      ? defineMessages(formatMessage({ id: 'TargetDetail_35', defaultMessage: '접속' }))
                      : defineMessages(formatMessage({ id: 'CtExamChart_6', defaultMessage: '다운' }))}
                  </span>
                </div>
                <div
                  className={cx('targetExam-item', { 'color-red': !!data.get('infectionEpoch') })}
                  title={
                    isPhishing
                      ? defineMessages(formatMessage({ id: 'TargetDetail_36', defaultMessage: '유출' }))
                      : defineMessages(formatMessage({ id: 'TargetDetail_12', defaultMessage: '감염' }))
                  }>
                  <span className={cx('title')}>
                    {isPhishing
                      ? defineMessages(formatMessage({ id: 'TargetDetail_36', defaultMessage: '유출' }))
                      : defineMessages(formatMessage({ id: 'TargetDetail_12', defaultMessage: '감염' }))}
                  </span>
                </div>
                {1 === data.get('examType') &&
                  2 === data.get('attachExamType') && (
                    <div
                      className={cx(
                        'targetExam-item',
                        { cure: !!data.get('cureEpoch') },
                        // 감염됬는되 치료 안됬을때
                        { 'color-red': !data.get('cureEpoch') && !!data.get('infectionEpoch') }
                      )}
                      title={defineMessages(formatMessage({ id: 'TargetDetail_34', defaultMessage: '치료' }))}>
                      <span className={cx('title')}>
                        {defineMessages(formatMessage({ id: 'TargetDetail_34', defaultMessage: '치료' }))}
                      </span>
                    </div>
                  )}
                {commonVar.isDeclare === 1 && (
                  <div className={cx('targetExam-item-righ-area')}>
                    <div
                      className={cx('targetExam-item-declare', { 'color-declare': !!data.get('declareEpoch') })}
                      title={defineMessages(formatMessage({ id: 'Declare_3', defaultMessage: '신고' }))}>
                      <Image
                        src={
                          !!data.get('declareEpoch')
                            ? '/img/declare/declare_10_on.png'
                            : '/img/declare/declare_10_off.png'
                        }
                      />
                      <span className={cx('title')}>
                        {defineMessages(formatMessage({ id: 'Declare_3', defaultMessage: '신고' }))}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {isOpenTargetExam.indexOf(data.get('examNo')) !== -1 && (
              <div className={cx('targetExam-detail')}>
                <div className={cx('date-area')}>
                  <div className={cx('bold mb-7')}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_13', defaultMessage: '일시' }))}
                  </div>
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {defineMessages(formatMessage({ id: 'TargetDetail_14', defaultMessage: '메일 발송' }))}
                    </div>
                    <div className={cx('detail-content')}>{common.timeFormatFromUTCEpoch(data.get('sendEpoch'))}</div>
                  </div>
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {defineMessages(formatMessage({ id: 'TargetDetail_15', defaultMessage: '메일 확인' }))}
                    </div>
                    <div className={cx('detail-content')}>{common.timeFormatFromUTCEpoch(data.get('readEpoch'))}</div>
                  </div>
                  {(2 & data.get('linkAttach') || isPhishing) && (
                    <div className={cx('targetExam-item')}>
                      <div className={cx('detail-title')}>
                        {isPhishing
                          ? defineMessages(formatMessage({ id: 'ExamDetail_51', defaultMessage: '피싱 접속' }))
                          : defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일 다운' }))}
                      </div>
                      <div className={cx('detail-content')}>
                        {common.timeFormatFromUTCEpoch(data.get('downloadEpoch'))}
                      </div>
                    </div>
                  )}
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {isPhishing
                        ? defineMessages(formatMessage({ id: 'ExamDetail_52', defaultMessage: '정보 유출' }))
                        : defineMessages(formatMessage({ id: 'TargetDetail_16', defaultMessage: '감염 파일 실행' }))}
                    </div>
                    <div className={cx('detail-content')}>
                      {common.timeFormatFromUTCEpoch(data.get('infectionEpoch'))}
                    </div>
                  </div>
                  {!isPhishing &&
                    1 === data.get('examType') &&
                    2 === data.get('attachExamType') && (
                      <div className={cx('targetExam-item')}>
                        <div className={cx('detail-title')}>
                          {1 === data.get('attachScreenType') &&
                            defineMessages(formatMessage({ id: 'CtExamChart_8', defaultMessage: '치료' }))}
                          {/* 비밀번호 입력 */}
                          {2 === data.get('attachScreenType') &&
                            defineMessages(formatMessage({ id: 'CtExamChart_9', defaultMessage: '치료(비밀번호)' }))}
                        </div>
                        <div className={cx('detail-content')}>
                          {common.timeFormatFromUTCEpoch(data.get('cureEpoch'))}
                        </div>
                      </div>
                    )}

                  {commonVar.isDeclare === 1 && (
                    <div className={cx('targetExam-item')}>
                      <div className={cx('detail-title')}>
                        {defineMessages(formatMessage({ id: 'Declare_3', defaultMessage: '신고' }))}
                      </div>
                      <div className={cx('detail-content')}>
                        {common.timeFormatFromUTCEpoch(data.get('declareEpoch'))}
                      </div>
                    </div>
                  )}
                </div>
                {!isPhishing &&
                  !!data.get('infectionPc') && (
                    <div className={cx('infectionPc-area')}>
                      <div className={cx('bold')}>
                        {defineMessages(formatMessage({ id: 'TargetDetail_17', defaultMessage: '감염 PC 목록' }))}
                      </div>
                      <div className={cx('infectionPc-content')}>
                        {data.get('infectionPc').map((pcData, index) => (
                          <div key={index} className={cx('infectionPc-item')}>
                            <div className={cx('pc-info', 'ellipsis')}>
                              <span className={cx('bold mr-5')}>·</span>
                              <span>{pcData.get('hostname') + ' (' + pcData.get('ip') + ')'}</span>
                            </div>
                            <div className={cx('date-info')}>
                              <span>
                                {defineMessages(
                                  formatMessage({ id: 'TargetDetail_30', defaultMessage: 'PC 감염 시간' })
                                )}
                              </span>
                              <span className={cx('date-text')}>
                                {common.timeFormatFromUTCEpoch(pcData.get('regEpoch'), 1)}
                              </span>
                            </div>
                            <div className={cx('count-area', 'ml-5')}>
                              <LeakCountInfo
                                formatMessage={formatMessage}
                                type="all"
                                count={pcData.get('leakAllcount')}
                                size={pcData.get('leakAllsize')}
                              />
                              <LeakCountInfo
                                formatMessage={formatMessage}
                                type="file"
                                count={pcData.get('leakFileCount')}
                                size={pcData.get('leakFileSize')}
                              />
                              <LeakCountInfo
                                formatMessage={formatMessage}
                                type="cert"
                                count={pcData.get('leakCertCount')}
                                size={pcData.get('leakCertSize')}
                              />
                              <LeakCountInfo
                                formatMessage={formatMessage}
                                type="mail"
                                count={pcData.get('leakEmailCount')}
                                size={pcData.get('leakEmailSize')}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
              </div>
            )}
          </div>
        );
      });

    // ----------------------------------------- 교육 이력 -----------------------------------------
    const EduListComponent =
      (eduList.get('data').size === 0 && (
        <div className={cx('brand-green')}>
          <Icon name="checkmark box" />
          {defineMessages(formatMessage({ id: 'Edu_33', defaultMessage: '학습 대상 없음' }))}
        </div>
      )) ||
      eduList.get('data').map((eduData, index) => (
        <div className={cx('infectionPc-set')} key={index}>
          <div className={cx('pc-info-area ellipsis')}>
            <div className={cx('pc-info', 'ellipsis')}>
              <span className={cx('bold mr-5')}>·</span>
              <Tooltip title={eduData.get('eduName')} placement="top">
                <span className={cx('pc')}>{eduData.get('eduName')}</span>
              </Tooltip>
            </div>
            <div className={cx('date-info')}>
              <span>{defineMessages(formatMessage({ id: 'Edu_8', defaultMessage: '컨텐츠' }))}</span>
              <Tooltip
                title={
                  defineMessages(formatMessage({ id: 'Edu_8', defaultMessage: '컨텐츠' })) +
                  ': ' +
                  eduData.get('attachName')
                }
                placement="top">
                <span className={cx('date-text')}>{eduData.get('attachName')}</span>
              </Tooltip>
            </div>
            <div className={cx('date-info')}>
              <span>{defineMessages(formatMessage({ id: 'Edu_2', defaultMessage: '교육 기간' }))}</span>
              <span className={cx('date-text')}>
                {common.timeFormatFromUTCEpoch(eduData.get('startEpoch'), 3) +
                  ' ~ ' +
                  common.timeFormatFromUTCEpoch(eduData.get('endEpoch'), 3)}
              </span>
            </div>
          </div>
          <div className={cx('display-flex mt-3 ml-7')}>
            {/* 발송 */}
            <ExamStep
              active={!!eduData.get('send') || eduData.get('eduStatus') === 1 || eduData.get('eduStatus') === 2}
              title={
                !!eduData.get('send')
                  ? defineMessages(formatMessage({ id: 'Edu_34', defaultMessage: '발송' })) +
                  ': ' +
                  common.timeFormatFromUTCEpoch(eduData.get('send'))
                  : eduData.get('eduStatus') === 1 || eduData.get('eduStatus') === 2
                    ? defineMessages(formatMessage({ id: 'Edu_34', defaultMessage: '발송' }))
                    : defineMessages(formatMessage({ id: 'Edu_35', defaultMessage: '준비' }))
              }
              stepType="send"
              stepComponent="eduSend"
            />
            {/* 열람 */}
            <ExamStep
              active={!!eduData.get('read') || eduData.get('eduStatus') === 1 || eduData.get('eduStatus') === 2}
              title={!!eduData.get('read') ? '열람: ' + common.timeFormatFromUTCEpoch(eduData.get('read')) : '열람'}
              stepType="read"
            />
            {/* 진행중 */}
            <ExamStep
              active={!!eduData.get('eduStatus') && (eduData.get('eduStatus') === 1 || eduData.get('eduStatus') === 2)}
              title="진행 중"
              stepType="edu_progress"
              eduStepStatus={eduData.get('eduStatus') === 1 ? eduData.get('playStep') : false}
            />
            {/* 완료 */}
            <ExamStep
              active={!!eduData.get('eduStatus') && eduData.get('eduStatus') === 2}
              title={!!eduData.get('finish') ? '완료: ' + common.timeFormatFromUTCEpoch(eduData.get('finish')) : '완료'}
              stepType="edu_end"
            />
          </div>
        </div>
      ));

    // ----------------------------------------- 메모 -----------------------------------------
    const MemoComponent = (
      <div className={cx('targetStatus', 'target-textarea')}>
        <div className={cx('editMode-area', 'no-enter')}>
          {isEditType === 'targetDetail' ? (
            <div>
              <ReduxFormMaterialTextField
                className={cx('target-reduxTextField')}
                name="targetDetail"
                autoFocus
                multiline
                rows="6"
                checkType={101}
                validate={['range5000']}
              />
              <div className={cx('bt-icon-area')}>
                <Button
                  className={cx('bt-icon')}
                  icon
                  title={defineMessages(formatMessage({ id: 'TargetDetail_6', defaultMessage: '저장' }))}
                  onClick={() => {
                    onEditSave();
                  }}>
                  <Icon name="checkmark" />
                </Button>
                <Button
                  className={cx('bt-icon')}
                  icon
                  title={defineMessages(formatMessage({ id: 'TargetDetail_7', defaultMessage: '취소' }))}
                  onClick={() => {
                    onEditCancel();
                  }}>
                  <Icon name="cancel" />
                </Button>
              </div>
            </div>
          ) : (
              <div
                className={cx('targetStatus-content', 'isEditPossible')}
                onClick={e => {
                  onActiveEditMode(e, targetInfo.get('targetDetail'), 'targetDetail', targetInfo.get('targetNo'));
                }}
                title={defineMessages(formatMessage({ id: 'TargetDetail_1', defaultMessage: '편집하려면 클릭하세요' }))}>
                <TextField
                  multiline
                  rows="6"
                  value={
                    !!targetInfo.get('targetDetail')
                      ? targetInfo.get('targetDetail')
                      : defineMessages(formatMessage({ id: 'TargetDetail_18', defaultMessage: '클릭하여 입력하세요' }))
                  }
                />
                <div className={cx('editIcon')}>
                  <Icon name="pencil" />
                </div>
              </div>
            )}
        </div>
      </div>
    );

    return (
      <DetailTemplate btDatas={btDatas} onMoveScroll={onMoveScroll} onToggleDetailView={onToggleDetailView}>
        <MaterialSnackbar isSnackbar={isSnackbar} onToggleSnackbar={onToggleSnackbar} />
        {/* ------------------------------------- 데이터가 없을 경우 ------------------------------------ */}
        {!!isNoData && (
          <Dimmer active inverted className={cx('isNoData')}>
            <div className={cx('isNoData-content')}>
              {/* <Icon name="pointing up" /> */}
              <Image className={cx('mr-5 info-select-icon')} src="/img/exam/info_select.png" />
              <div className={cx('text')}>
                {defineMessages(formatMessage({ id: 'TargetDetail_19', defaultMessage: '대상자를 선택하세요.' }))}
              </div>
            </div>
          </Dimmer>
        )}
        <Scrollbar
          ref={Scroll => {
            onRefRegister('scroll', Scroll);
          }}>
          <div className={cx('element-wrapper')}>
            {/* ----------------------------------------- 대상자 정보 ----------------------------------------- */}
            {!!btDatas[btDatas.findIndex(btId => btId.id === 'move-info')].isView && (
              <div
                className={cx('element')}
                ref={ref => {
                  onRefRegister('move-info', ref);
                }}>
                <div className={cx('segment-title')}>
                  <span className={cx('toggle-title bold')}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_2', defaultMessage: '대상자 정보' }))}
                  </span>
                </div>
                <div className={cx('segment-content')}>
                  <div className={cx('targetStatus')}>
                    <div className={cx('targetStatus-title')}>
                      {defineMessages(formatMessage({ id: 'TargetDetail_20', defaultMessage: '대상자 번호' }))}
                    </div>
                    <div className={cx('targetStatus-content', 'no-edit')}>{targetInfo.get('targetNo')}</div>
                  </div>
                  <div className={cx('targetStatus')}>
                    <div className={cx('targetStatus-title')}>
                      {defineMessages(formatMessage({ id: 'TargetDetail_21', defaultMessage: '이름' }))}
                    </div>
                    <div className={cx('targetStatus-content')}>
                      {isEditType !== 'targetName' ? (
                        <TargetInfoComponent
                          formatMessage={formatMessage}
                          value={targetInfo.get('targetName')}
                          type="targetName"
                          targetNo={targetInfo.get('targetNo')}
                          onActiveEditMode={onActiveEditMode}
                        />
                      ) : (
                          <div className={cx('editMode-area')}>
                            <ReduxFormMaterialTextField
                              className={cx('target-textField')}
                              validate={['required', 'targetName']}
                              autoFocus
                              name="targetName"
                              checkType={101}
                            />
                            {EditButton}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className={cx('targetStatus')}>
                    <div className={cx('targetStatus-title')}>
                      {defineMessages(formatMessage({ id: 'TargetDetail_22', defaultMessage: '이메일' }))}
                    </div>
                    <div className={cx('targetStatus-content')}>
                      {isEditType !== 'targetEmail' ? (
                        <TargetInfoComponent
                          formatMessage={formatMessage}
                          value={targetInfo.get('targetEmail')}
                          type="targetEmail"
                          targetNo={targetInfo.get('targetNo')}
                          onActiveEditMode={onActiveEditMode}
                        />
                      ) : (
                          <div className={cx('editMode-area')}>
                            <ReduxFormMaterialTextField
                              className={cx('target-textField')}
                              name="targetEmail"
                              autoFocus
                              validate={['required', 'email']}
                              checkType={101}
                            />
                            {EditButton}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className={cx('targetStatus')}>
                    <div className={cx('targetStatus-title')}>
                      {defineMessages(formatMessage({ id: 'TargetDetail_23', defaultMessage: '연락처' }))}
                    </div>
                    <div className={cx('targetStatus-content')}>
                      {isEditType !== 'targetPhone' ? (
                        <TargetInfoComponent
                          formatMessage={formatMessage}
                          value={targetInfo.get('targetPhone')}
                          type="targetPhone"
                          targetNo={targetInfo.get('targetNo')}
                          onActiveEditMode={onActiveEditMode}
                        />
                      ) : (
                          <div className={cx('editMode-area')}>
                            <ReduxFormMaterialTextField
                              className={cx('target-textField')}
                              validate={['userPhone']}
                              autoFocus
                              name="targetPhone"
                              checkType={101}
                            />
                            {EditButton}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className={cx('targetStatus')}>
                    <div className={cx('targetStatus-title')}>
                      {defineMessages(formatMessage({ id: 'TargetDetail_24', defaultMessage: '소속' }))}
                    </div>
                    <div className={cx('targetStatus-content')}>
                      {isEditType !== 'targetDivision' ? (
                        <TargetInfoComponent
                          formatMessage={formatMessage}
                          value={targetInfo.get('targetDivision')}
                          type="targetDivision"
                          targetNo={targetInfo.get('targetNo')}
                          onActiveEditMode={onActiveEditMode}
                        />
                      ) : (
                          <div className={cx('editMode-area')}>
                            <ReduxFormMaterialTextField
                              className={cx('target-textField')}
                              name="targetDivision"
                              validate={['targetDivision']}
                              autoFocus
                              checkType={101}
                            />
                            {EditButton}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className={cx('targetStatus')}>
                    <div className={cx('targetStatus-title')}>
                      {defineMessages(formatMessage({ id: 'TargetDetail_25', defaultMessage: '직급' }))}
                    </div>
                    <div className={cx('targetStatus-content')}>
                      {isEditType !== 'targetPosition' ? (
                        <TargetInfoComponent
                          formatMessage={formatMessage}
                          value={targetInfo.get('targetPosition')}
                          type="targetPosition"
                          targetNo={targetInfo.get('targetNo')}
                          onActiveEditMode={onActiveEditMode}
                        />
                      ) : (
                          <div className={cx('editMode-area')}>
                            <ReduxFormMaterialTextField
                              className={cx('target-textField')}
                              name="targetPosition"
                              validate={['targetPosition']}
                              autoFocus
                              checkType={101}
                            />
                            {EditButton}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className={cx('targetStatus')}>
                    <div className={cx('targetStatus-title')}>
                      {defineMessages(formatMessage({ id: 'TargetDetail_26', defaultMessage: '등록한 계정' }))}
                    </div>
                    <div className={cx('targetStatus-content', 'no-edit')}>
                      {(!!targetInfo.get('userName') ? targetInfo.get('userName') : '-') +
                        (!!targetInfo.get('userEmail') ? '(' + targetInfo.get('userEmail') + ')' : '')}
                    </div>
                  </div>
                  <div className={cx('targetStatus')}>
                    <div className={cx('targetStatus-title')}>
                      {defineMessages(formatMessage({ id: 'TargetDetail_27', defaultMessage: '등록일' }))}
                    </div>
                    <div className={cx('targetStatus-content', 'no-edit')}>
                      {common.timeFormatFromUTCEpoch(targetInfo.get('regEpoch'), 2)}
                    </div>
                  </div>
                  <div className={cx('targetStatus')}>
                    <div className={cx('targetStatus-title')}>
                      {defineMessages(formatMessage({ id: 'TargetDetail_28', defaultMessage: '마지막 수정일' }))}
                    </div>
                    <div className={cx('targetStatus-content', 'no-edit')}>
                      {common.timeFormatFromUTCEpoch(targetInfo.get('modifyEpoch'), 2)}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* ----------------------------------------- 태그 ----------------------------------------- */}
            {!!btDatas[btDatas.findIndex(btId => btId.id === 'move-tag')].isView && (
              <div
                className={cx('element')}
                ref={ref => {
                  onRefRegister('move-tag', ref);
                }}>
                <div className={cx('segment-title')}>
                  <span className={cx('toggle-title bold')}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_3', defaultMessage: '태그' }))}
                  </span>
                </div>
                <div className={cx('segment-content', 'tag-content', 'target-tags')}>{TagListComponent}</div>
              </div>
            )}
            {/* ----------------------------------------- 훈련 이력 ----------------------------------------- */}
            {!!btDatas[btDatas.findIndex(btId => btId.id === 'move-examList')].isView && (
              <div
                className={cx('element')}
                ref={ref => {
                  onRefRegister('move-examList', ref);
                }}>
                <div className={cx('segment-title')}>
                  <span className={cx('toggle-title bold')}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_4', defaultMessage: '훈련 이력' }))}
                  </span>
                </div>
                <div className={cx('segment-content')}>
                  {isLoadingTargetExam && (
                    <div className={cx('Loading')}>
                      <Loading content={'Loading...'} />
                    </div>
                  )}
                  {targetExam.get('data').size > 0 && !!targetExam.get('chartData') ? (
                    <TargetDetailExamChart targetExam={targetExam} detailType="total" />
                  ) : (
                      ''
                    )}
                  {targetExam.get('data').size > 0 && !!targetExam.get('chartData') ? (
                    <TargetDetailExamChart targetExam={targetExam} detailType="attach" />
                  ) : (
                      ''
                    )}
                  {targetExam.get('data').size > 0 && !!targetExam.get('chartData') ? (
                    <TargetDetailExamChart targetExam={targetExam} detailType="phishing" />
                  ) : (
                      ''
                    )}
                  {ExamListComponent}
                  {targetExam.get('totalPages') > 1 &&
                    targetExam.get('totalPages') > targetExam.get('page') &&
                    targetExam.get('data').size > 0 && (
                      <div className={cx('bt-addView')} onClick={() => onGetTargetExamList()}>
                        <Icon name="plus circle" />
                        {defineMessages(formatMessage({ id: 'TargetDetail_29', defaultMessage: '더보기' }))}
                      </div>
                    )}
                </div>
              </div>
            )}
            {/* ----------------------------------------- 교육 이력 ----------------------------------------- */}
            {/* ----------------------------------------- 교육 이력 ----------------------------------------- */}
            {commonVar.isEdu === 1 && (
              <div className={cx('element')}>
                <div className={cx('segment-title')}>
                  <span className={cx('toggle-title bold')}>
                    {defineMessages(formatMessage({ id: 'Edu_22', defaultMessage: '교육 이력' }))}
                  </span>
                </div>
                <div className={cx('segment-content')}>
                  {isLoadingEdu && (
                    <div className={cx('Loading')}>
                      <Loading content={'Loading...'} />
                    </div>
                  )}
                  {EduListComponent}
                  {eduList.get('totalPages') > 1 &&
                    eduList.get('totalPages') > eduList.get('page') &&
                    eduList.get('data').size > 0 && (
                      <div className={cx('bt-addView')} onClick={() => onGetEduHistory()}>
                        <Icon name="plus circle" />
                        {defineMessages(formatMessage({ id: 'TargetDetail_29', defaultMessage: '더보기' }))}
                      </div>
                    )}
                </div>
              </div>
            )}
            {/* ----------------------------------------- 메모 ----------------------------------------- */}
            {!!btDatas[btDatas.findIndex(btId => btId.id === 'move-memo')].isView && (
              <div
                className={cx('element')}
                ref={ref => {
                  onRefRegister('move-memo', ref);
                }}>
                <div className={cx('segment-title')}>
                  <span className={cx('toggle-title bold')}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_5', defaultMessage: '메모' }))}
                  </span>
                </div>
                <div className={cx('segment-content')}>{MemoComponent}</div>
              </div>
            )}
          </div>
        </Scrollbar>
      </DetailTemplate>
    );
  }
}

TargetDetail.propTypes = {};

const mapStateToProps = (state, { isEditType, isEditData }) => {
  return {
    initialValues: {
      targetName: isEditType === 'targetName' && isEditData.get('targetName'),
      targetEmail: isEditType === 'targetEmail' && isEditData.get('targetEmail'),
      targetPhone: isEditType === 'targetPhone' && isEditData.get('targetPhone'),
      targetDivision: isEditType === 'targetDivision' && isEditData.get('targetDivision'),
      targetPosition: isEditType === 'targetPosition' && isEditData.get('targetPosition'),
      targetTag: isEditType === 'targetTag' && isEditData.get('targetTag'),
      targetDetail: isEditType === 'targetDetail' && isEditData.get('targetDetail')
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'formTargetEdit',
    enableReinitialize: true,
    asyncValidate: targetEmailAsyncValidate,
    asyncBlurFields: ['targetEmail'],
    destroyOnUnmount: false,
    touchOnChange: true // validation 안내를 적절한 시점에 보이기 위해 반드시 필요함
  })(injectIntl(TargetDetail))
);



// WEBPACK FOOTER //
// ./src/script/components/target/TargetDetail.js